import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { onMounted, onUnmounted, onUpdated, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

const route = useRoute();

onMounted(() => {
  setTimeout(() => {
    console.log(route.params, route.query);
    const salonId = +route.params.SALON_ID;
    const orderId = route.query.order_id;

    store.state.salonId = salonId;
    store.state.orderId = orderId;

    if (salonId) {
      store.dispatch("getDesignsBySalonId");
      store.dispatch("getAllLoyalityTypes").then(() => {
        if (orderId) {
          console.log(route);
          store.dispatch("getCurrentPagePayment").then(() => {
            if (route.query.pay === "success") {
              store.dispatch("postSuccessPagePaymentStatus");
            }
          });
        }
      });
    }
  }, 20);


});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})